import { Component, Input, OnChanges, OnInit,Renderer2,ElementRef,ViewChild} from '@angular/core';
import {FormControl, FormBuilder, Validators, FormGroup, AbstractControl} from '@angular/forms';
import {productValues} from "../../constants";
import {CalculateAaeroAgeoService} from '../../services/calculateAaeroAgeo.service';
import {UwService} from '../../services/uw.service';
import {CurrentSystemService} from '../../services/currentSystem.service';
import {WindLoadService} from '../../services/windLoad.service';
import {productValuesType, louvreArea, area, UgAgPsiTotal, areaFLLPsiTotalAw} from '../../interfaces';
import { formatNumber } from '@angular/common';
import { debounceTime } from 'rxjs/operators';
import {el} from "@angular/platform-browser/testing/src/browser_util";
import { DecimalPipe } from '@angular/common';

@Component({
	selector: 'lib-fiegerCalculatorCore',
	templateUrl: './calculator.component.html',
	styleUrls: ['./calculator.component.scss']
})
export class CalculatorComponent implements OnInit, OnChanges {

	@Input() language: string;
	@Input() platform: string;
	@Input() fragment: string;

	allProducts = ['FLW40', 'FLW32', 'FLW28', 'FLW24', 'FLL', 'FLM'];
	middleMullionMassage = 'Bitte aktivieren Sie den Mittelpfosten.';
	showMiddleMullionMassage = false;
	debug = false;
	middleMullionPossible = false;
	middleMullion = false;
	glassType = 0;
	window = {max:0, min:0};
	index = 0;
	aAero = null;
	aAeroTotal = null;
	aGeo = null;
	aGeoTotal = null;
	uw = null;
	tableData: any;
	windLoadSecurity = '';
	louvreArea: louvreArea;
	area: area;
	areaFLLPsiTotalAw: areaFLLPsiTotalAw;
	UgAgPsiTotal: UgAgPsiTotal;
	louvres = [];
	currentSystem = 'FLW40';
	pv: productValuesType;
	inputValues = {};
	myForm: FormGroup;

	constructor(
		private fb: FormBuilder,
		private renderer: Renderer2,
		private decimalPipe: DecimalPipe,
		private calcAaeroAgeoService: CalculateAaeroAgeoService,
		private uwService: UwService,
		private currentSystemService: CurrentSystemService,
		private windLoadService: WindLoadService) {
	}

	ngOnInit() {
		this.setAll(this.currentSystem);
	}

	ngOnChanges(){
		if (this.fragment) {
			console.log(this.fragment);
			const fragment = this.fragment.toLocaleUpperCase();
			this.currentSystem = this.allProducts.indexOf(fragment) >= 0 ? fragment : this.currentSystem;
		}
		this.setAll(this.currentSystem);
	}

	/**
	 * set current values depends on selected product
	 * @param currentSystem
	 */
	setAll(currentSystem: string){
		this.currentSystem = currentSystem;
		this.pv = productValues[this.currentSystem];
		this.currentSystemService.updateCurrentSystem(currentSystem);
		this.calcAaeroAgeoService.setCurrentSystem();
		this.uwService.setCurrentSystem();
		this.windLoadService.setCurrentSystem();
		this.middleMullionPossible = this.pv.fixedValues.middleMullion;
		this.middleMullion = this.showMiddleMullionMassage = false;
		this.window = {
			max: this.pv.windowWidth.max,
			min: this.pv.windowWidth.min,
		};
		this.glassType = this.pv.defaultValues.glassTypes;
		let glassTypes = '';
		switch (this.glassType) {
			case 2:
				glassTypes = 'glass3';
				break;
			case 1:
				glassTypes = 'glass2';
				break;
			default:
				glassTypes = 'glass0';
		}

		this.inputValues = {
			'windowQuantity': [this.pv.defaultValues.windowQuantity, Validators.compose([Validators.min(1), Validators.max(1000), Validators.required])],
			'width': [this.pv.defaultValues.width, [this.validWidth.bind(this), Validators.required]],
			'height': [this.pv.defaultValues.height, Validators.compose([ Validators.min(this.pv.windowHeight.min), Validators.max(this.pv.windowHeight.max), Validators.required])],
			'nrLouvres': [],
			'glassThickness': [this.pv.defaultValues.glassThickness],
			'middleMullion': [this.pv.defaultValues.middleMullion],
			'glassTypes': [this.glassType],
			'ug': [this.pv.defaultValues.ug[glassTypes]],
			'psi': [this.pv.defaultValues.psi[glassTypes]],
			'isolation': this.pv.defaultValues.isolation,
			'louvresHeight': [0]
		};
		this.myForm = this.fb.group( this.inputValues);
		this.myForm.controls['louvresHeight'].disable();
		if ( this.currentSystem != 'FLM') {
			this.myForm.controls['glassThickness'].disable();
		}
		if (this.currentSystem === 'FLL') {
			this.myForm.controls['height'].disable();
		}
		this.setCalculateValues();
		this.onFormChanges();
		// console.log(this.pv);
	}

	/**
	 * check max and min width depends on middle mullion
	 * @param control
	 */
	validWidth(control: AbstractControl) {
		if (control.value > this.window.max || control.value < this.window.min) {
			return { validWidth: true };
		}
		return null;
	}

	setCalculateValues(){
		const width = this.myForm.get('width').value;
		this.setLouvres(this.myForm.get('height').value);
		this.setHeight();
		this.setAaeroAndAgeo(width, this.myForm.get('height').value);
		this.setWindLoad();
		// console.log(this.louvreArea);
	}

	/**
	 * Subscribe all form chang event listener
	 * on form changes calculate values
	 */
	onFormChanges() {
		this.myForm.get('middleMullion').valueChanges.pipe(debounceTime(500)).subscribe(middleMullion => {
			this.middleMullion = middleMullion;

			const height = this.myForm.get('height').value;
			const width = this.myForm.get('width').value;
			if (width > this.pv.windowWidth.max && this.middleMullion) {
				this.window.max = this.pv.middleMullion.max;
			} else {
				this.window.max = this.pv.windowWidth.max;
			}
			// set width again to control error massage after middle mullion is set and new min an max width
			if (width >= this.pv.middleMullion.min) {
				this.myForm.get('width').setValue(width);
			}

			this.setLouvres(height);
			this.setAaeroAndAgeo(width, height);
		});

		this.myForm.get('isolation').valueChanges.pipe(debounceTime(500)).subscribe(iso => {
			// this.setLouvres(this.myForm.get('height').value);
			this.setWindLoad();
		});

		this.myForm.get('windowQuantity').valueChanges.pipe(debounceTime(500)).subscribe(quantity => {

			this.aAeroTotal =  this.setAgeoAndAaeroTotal(quantity, this.aAero);
			this.aGeoTotal = this.setAgeoAndAaeroTotal(quantity, this.aGeo);

		});

		this.myForm.get('height').valueChanges.pipe(debounceTime(500)).subscribe(height => {
			if (this.currentSystem != 'FLL') {
				this.setLouvres(height);
			}
			this.setAaeroAndAgeo(this.myForm.get('width').value, height);
			this.setWindLoad();
		});
		this.myForm.get('width').valueChanges.pipe(debounceTime(500)).subscribe(width => {
			const middleMullion = this.myForm.get('middleMullion').value;
			if (middleMullion) {
				this.window.max = this.pv.middleMullion.max;
			} else {
				this.window.max = this.pv.windowWidth.max;
			}
			this.checkMiddleMullion(width);
			this.setAaeroAndAgeo(width, this.myForm.get('height').value);
			this.setWindLoad();

		});
		this.myForm.get('nrLouvres').valueChanges.pipe(debounceTime(500)).subscribe(louvreCount => {
			const height = this.myForm.get('height').value;
			this.setAgeo(this.myForm.get('width').value, height, louvreCount, this.myForm.get('glassThickness').value);
			if (this.currentSystem != 'FLL') {
				this.myForm.get('louvresHeight').setValue(this.calcAaeroAgeoService.calculateLouvreHeight(height, louvreCount, this.myForm.get('middleMullion').value ));
			}
			this.setHeight();
			this.setWindLoad();
		});
		this.myForm.get('isolation').valueChanges.pipe(debounceTime(500)).subscribe(isolation => {
			// console.log(`isolation: ${isolation}`);
		});
		this.myForm.get('glassTypes').valueChanges.pipe(debounceTime(500)).subscribe(glassType => {
			this.glassType = glassType;
			if (this.glassType === 0) {
				this.myForm.controls['psi'].disable();
				this.myForm.get('ug').setValue( this.pv.defaultValues.ug.panel);
				this.myForm.get('psi').setValue( this.pv.defaultValues.psi.panel);
			} else if (this.glassType  === 1) {
				this.myForm.controls['psi'].enable();
				this.myForm.get('ug').setValue(this.pv.defaultValues.ug.glass2);
				this.myForm.get('psi').setValue(this.pv.defaultValues.psi.glass2);
			} else {
				this.myForm.controls['psi'].enable();
				this.myForm.get('ug').setValue(this.pv.defaultValues.ug.glass3);
				this.myForm.get('psi').setValue(this.pv.defaultValues.psi.glass3);
			}
		});
		this.myForm.get('ug').valueChanges.pipe(debounceTime(500)).subscribe( ug => {
			this.setWindLoad();
		});
		this.myForm.get('psi').valueChanges.pipe(debounceTime(500)).subscribe( psi => {
			this.setWindLoad();
		});

		if (this.currentSystem === 'FLM') {
			this.myForm.get('glassThickness').valueChanges.pipe(debounceTime(500)).subscribe( glass => {
				this.setWindLoad();
				this.setAgeo(this.myForm.get('width').value, this.myForm.get('height').value, this.myForm.get('nrLouvres').value, glass);
			});
		}
	}

	onChangeUp($event){
		const str = $event.source.triggerValue;
		let name = str.substring(0, str.lastIndexOf(' '));
		console.log(name);
		const psi = this.pv.fixedValues.psi.up.find(o => o.name === name);
		this.myForm.get('psi').setValue( psi.value);
	}

	/**
	 * Set wind load
	 */
	setWindLoad(){
		const width = this.myForm.get('width').value;
		const height = this.myForm.get('height').value;
		const louvresHeight = this.myForm.get('louvresHeight').value;
		const louvreWidth = this.uwService.calculateLouvreWidth(width, this.middleMullion);
		const nrLouvres = this.myForm.get('nrLouvres').value;
		const ug = this.myForm.get('ug').value;
		const psi = this.myForm.get('psi').value;
		const isolation = this.myForm.get('isolation').value;
		this.area = this.uwService.calcArea(width, height, nrLouvres, psi, this.middleMullion);
		this.louvreArea = this.uwService.calculateLouvreAreas(width, height, nrLouvres, louvresHeight, ug, psi, this.middleMullion);
		this.UgAgPsiTotal = this.uwService.calculateUgPsiTotal(ug, psi);
		if (this.currentSystem === 'FLL') {
			this.areaFLLPsiTotalAw = this.uwService.calculateAreaFLL(width, height, nrLouvres, this.middleMullion);
			// console.log('areaFLLPsiTotalAw: ',this.areaFLLPsiTotalAw);
		}

		this.uw = this.uwService.getUwValue(isolation);
		if (this.currentSystem === 'FLM') {
			this.uw = null;
		}
		this.windLoadSecurity = this.windLoadService.setWindLoad(louvreWidth, louvresHeight, this.louvreArea, this.myForm.get('glassThickness').value);
		// console.log('UW', this.uw);
		// console.log(this.UgAgPsiTotal);
	}

	/**
	 * set aaeore and aeoreTotal
	 * @param width
	 * @param height
	 */
	setAaeroAndAgeo(width: number, height: number){
		this.aAero = this.calcAaeroAgeoService.calcAaero(width, height);
		this.aAeroTotal = this.setAgeoAndAaeroTotal(this.myForm.get('windowQuantity').value,  this.aAero);
		this.setAgeo(width, height, this.myForm.get('nrLouvres').value, this.myForm.get('glassThickness').value);
	}

	/**
	 * set ageo
	 * @param width
	 * @param height
	 * @param louvreCount
	 * @param glass
	 */
	setAgeo(width: number, height: number, louvreCount: number, glass: number) {
		const mm = this.myForm.get('middleMullion').value;
		//const glass = this.pv.defaultValues.glassThickness;
		this.aGeo = this.calcAaeroAgeoService.calculateAgeo(width, height, louvreCount, mm, glass );
		// console.log('this.aGeo',this.aGeo, parseFloat(formatNumber(this.aGeo, 'en', '1.0-1')));
		this.aGeoTotal = this.setAgeoAndAaeroTotal(this.myForm.get('windowQuantity').value, this.aGeo);
	}

	/**
	 * set Ageo and Aaero total
	 * @param windowQuantity
	 * @param value
	 */
	private setAgeoAndAaeroTotal (windowQuantity: number, value : number) {
		return windowQuantity * Math.round(value * 100) / 100;
	}

	/**
	 * set louvres array
	 * @param height
	 */
	setLouvres(height: number){

		const values = this.calcAaeroAgeoService.changeLouvresValues(height, this.myForm.get('middleMullion').value);
		this.louvres = values.louvres;
		this.myForm.get('nrLouvres').setValue( Math.round((values.min + values.max) / 2));
		if (this.middleMullion && ((values.min + values.max) / 2) % 2 != 0 ) {
			this.myForm.get('nrLouvres').setValue( Math.round((values.min + values.max) / 2) + 1);
		}

		const louvreHeight = this.currentSystem === 'FLL'? 131 : this.calcAaeroAgeoService.calculateLouvreHeight(height, this.myForm.get('nrLouvres').value, this.myForm.get('middleMullion').value);

		console.log(louvreHeight);
		this.myForm.get('louvresHeight').setValue(louvreHeight);
	}

	/**
	 * set element height only for FLL
	 */
	setHeight(){
		if ( this.currentSystem != 'FLL') {
			return
		}
		const mm = this.myForm.get('middleMullion').value;
		const nrLouvres = mm ?  this.myForm.get('nrLouvres').value / 2 :  this.myForm.get('nrLouvres').value;

		if(nrLouvres > 0) {
			this.myForm.get('height').setValue (
				45 + nrLouvres * 136
			);
		} else {
			this.myForm.get('height').setValue ( 0);
		}
	}

	/**
	 * check if mm is possible or have to
	 * @param width
	 */
	checkMiddleMullion(width: number){

		const middleMullion = this.myForm.get('middleMullion').value;

		if (!this.pv.fixedValues.middleMullion) {
			this.showMiddleMullionMassage = false;
			return;
		}
		if( width >= this.pv.middleMullion.min && width <= this.pv.windowWidth.max) {
			this.middleMullionPossible = true;
			this.showMiddleMullionMassage = false;
			return console.log('MP möglich')
		}
		if (width > this.pv.windowWidth.max && width <= this.pv.middleMullion.max) {
			this.middleMullionPossible = this.showMiddleMullionMassage = true;
			//this.myForm.get('middleMullion').setValue(true);
			return console.log('MP notwendig');
		}
		if (width > this.pv.middleMullion.max ) {
			this.showMiddleMullionMassage = !middleMullion;
			this.middleMullionPossible = true;
			return console.log('window to big');
		}
		this.myForm.get('middleMullion').setValue(false);
		this.middleMullionPossible = this.middleMullion = this.showMiddleMullionMassage = false;
		return console.log('MP nicht möglich');
	}

	/**
	 * add new row to table
	 */
	addToTable(){
		const width = this.myForm.get('width').value;
		let middleMullion = false;
		if ( this.middleMullionPossible) {
			middleMullion =  width >= this.pv.middleMullion.min ? this.myForm.get('middleMullion').value : false
		}
		this.tableData = {
			id: this.index,
			system: this.currentSystem,
			isolation: this.myForm.get('isolation').value,
			middleMullion: middleMullion,
			windowQuantity: this.myForm.get('windowQuantity').value,
			dimension: width + ' / ' + this.myForm.get('height').value,
			louvre: this.myForm.get('nrLouvres').value + ' / ' + this.myForm.get('louvresHeight').value,
			ug: this.myForm.get('ug').value,
			glassThickness: this.myForm.get('glassThickness').value,
			glassType: this.myForm.get('glassTypes').value,
			psi: this.myForm.get('psi').value,
			aGeoTotal: this.aGeoTotal,
			aAeroTotal: this.aAeroTotal,
			uw: this.uw,
			windLoad: this.windLoadSecurity
		};
	}

	sendEmail(){
		const width = this.myForm.get('width').value;
		let middleMullion = false;
		if ( this.middleMullionPossible) {
			middleMullion =  width >= this.pv.middleMullion.min ? this.myForm.get('middleMullion').value : false
		}

			const emailContent = 'System:  ' + this.currentSystem +
			'%0D%0AFenster:  ' + this.myForm.get('windowQuantity').value+
			'%0D%0AMittelpfosten:  ' + this.trueOrFalse(middleMullion) +
			'%0D%0ABreite:  ' + width +
			'%0D%0AHöhe:  ' + this.myForm.get('height').value +
			'%0D%0ALamellen:  ' + this.myForm.get('nrLouvres').value +
			'%0D%0ALamellenhöhe:  ' + this.myForm.get('louvresHeight').value +
			'%0D%0AUg:  ' + this.myForm.get('ug').value +
			'%0D%0AGlasdicke:  ' + this.myForm.get('glassThickness').value +
			'%0D%0AGlas:  ' + this.showGlassTypes(this.myForm.get('glassTypes').value, this.currentSystem) +
			'%0D%0AΨ:  ' + this.myForm.get('psi').value +
			'%0D%0AA geom(Ges):  ' + this.aGeoTotal +
			'%0D%0AA aero(Ges):  ' + this.aAeroTotal +
			'%0D%0ADämmung:  ' + this.trueOrFalse(this.myForm.get('isolation').value)  +
			'%0D%0AUW:  ' + this.decimalPipe.transform(this.uw , '1.0-2')+
			'%0D%0AWindlast:  ' + this.windLoadSecurity ;
		window.location.href = 'mailto:?subject=System: ' + this.currentSystem +'&body=' + emailContent;

	}

	trueOrFalse(boolen){
		return boolen ? 'Ja' : 'Nein'
	}

	showGlassTypes(type, system){
		console.log(system);
		let glassType = '';
		switch (type) {
			case 2:
				glassType = '3-fach-Glass';
				break;
			case 1:
				glassType = '2-fach-Glass';
				break;
			default:
				glassType = 'Paneele';
		}
		return system !== 'FLM' ? glassType : '-';
	}

	onFormSubmit(value){
	}
}
